import { useCallback, useEffect, useState } from "react";
import { SQCReponseService } from "../../../../../service/SQC_form/SQCReponseService";
import { CardHeader, Divider, Grid, Typography } from "@mui/material";
import useToast from "../../../../../hooks/useToast";
import StandardSkeletoon from "../../../shares/loader/StandardSkeletoon";
import { exportToExcelJS } from "../../../../../Helpers/ExcelJsHelper";

const ResumerReponseList = ({
  association,
  id_type,
  downloadExcel,
  refresh,
}) => {
  const [reponses, setReponses] = useState([]);
  const [loadingPage, setLoadingPage] = useState(false);
  const { Toast, showToast } = useToast();

  const downloadExcelFile = (downloadExcel) => {
    if (downloadExcel <= 0) {
      return;
    }
    let columns = [
      { headerName: "Question", field: "question", width: 150 },
      { headerName: "Reponse", field: "reponse", width: 100 },
      { headerName: "commentaire", field: "commentaire", width: 125 },
      { headerName: "pj", field: "pj", width: 75 },
      { headerName: "lien", field: "pj_link", width: 250 },
    ];
    exportToExcelJS(reponses, columns, "Résumé_des_réponses");
  };

  const handleFetchReponses = () => {
    setLoadingPage(true);
    if (association.id_ext_association) {
      SQCReponseService.getResumeByIDAssociationAndType(
        association.id_ext_association,
        id_type
      )
        .then((response) => {
          setReponses(response.data || []);
        })
        .catch((error) => {
          console.error("Error fetching responses:", error);
        })
        .finally(() => {
          setLoadingPage(false);
        });
    }
  };

  useEffect(() => {
    if (downloadExcel > 0) {
      downloadExcelFile(downloadExcel);
    }
  }, [downloadExcel]);

  useEffect(() => {
    if (refresh > 0) {
      handleFetchReponses();
    }
  }, [refresh]);

  useEffect(() => {
    handleFetchReponses();
  }, [association.id_ext_association, id_type]);

  return (
    <>
      <Toast />
      <Grid
        display={loadingPage && association.id_ext_association ? "" : "none"}
        overflow={"auto"}
      >
        {Array.from({ length: 4 }).map((_, index) => (
          <Grid m={1} key={index} style={{ marginBottom: "10px" }}>
            <StandardSkeletoon
              show={loadingPage}
              row={3}
              col={1}
              escalier={true}
            />
          </Grid>
        ))}
      </Grid>
      <Grid
        p={1}
        display={loadingPage && association.id_ext_association ? "none" : ""}
      >
        <Grid item maxHeight={"55vh"} height={"55vh"} overflow={"auto"}>
          {reponses.map((reponse, index) => (
            <>
              <CardHeader
                title={<Grid>{`Q${index + 1} : ${reponse.question}`}</Grid>}
                titleTypographyProps={{ variant: "h6" }}
                key={index}
                subheader={
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography variant="body2" color="textSecondary">
                        Reponse : {reponse.reponse}
                      </Typography>
                      <Typography
                        sx={{ mt: 1 }}
                        display={reponse.commentaire ? "" : "none"}
                        variant="body2"
                        color="textSecondary"
                      >
                        Commentaire :<br /> {reponse.commentaire}
                      </Typography>
                      <Typography
                        sx={{ mt: 1 }}
                        variant="body2"
                        color="textSecondary"
                      >
                        Pj :{" "}
                        <a
                          href={reponse.pj_link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {reponse.pj}
                        </a>{" "}
                        {reponse.pj ? "" : "Aucune pièce jointe"}
                      </Typography>
                    </Grid>
                  </Grid>
                }
              />
              <Divider variant="middle" />
            </>
          ))}
          {reponses.length === 0 && (
            <Grid
              justifyItems={"center"}
              textAlign={"center"}
              mt={3}
              alignContent={"center"}
              height={"90%"}
              flexGrow={1}
            >
              Aucun résultat à afficher
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default ResumerReponseList;
